"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.walkNodes = exports.matchSelectorParts = exports.matchSelectorPartsWithStates = void 0;
var tslib_1 = require("tslib");
function matchSelectorPartsWithStates(astA, astB) {
    return matchSelectorParts(astA, astB, {
        selectorAFilter: function (node) { return !(node.type === 'pseudo-class' || node.type === 'nested-pseudo-class'); },
    });
}
exports.matchSelectorPartsWithStates = matchSelectorPartsWithStates;
function matchSelectorParts(astA, astB, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.selectorBFilter, selectorBFilter = _c === void 0 ? function (_node) { return true; } : _c, _d = _b.selectorAFilter, selectorAFilter = _d === void 0 ? function (_node) { return true; } : _d;
    var a = separateChunks(astA);
    var b = separateChunks(astB);
    if (a.length !== 1) {
        throw new Error('only single selector allowed');
    }
    var firstSelectorAChunks = a[0];
    return b.some(function (selectorBChunks) {
        if (firstSelectorAChunks.length !== selectorBChunks.length) {
            return false;
        }
        var _loop_1 = function (i) {
            var e_1, _a;
            var chunkA = firstSelectorAChunks[i];
            var chunkB = selectorBChunks[i];
            if (chunkA.type !== chunkB.type) {
                return { value: false };
            }
            if (chunkA.operator !== chunkB.operator) {
                return { value: false };
            }
            var filteredFromA = [];
            var nodesA = chunkA.nodes.filter(function (node) {
                if (selectorAFilter(node)) {
                    return true;
                }
                else {
                    filteredFromA.push(node);
                    return false;
                }
            });
            var nodesB = chunkB.nodes
                .filter(selectorBFilter)
                .filter(function (node) { return !filteredFromA.some(function (nodeA) { return isSameNode(nodeA, node); }); });
            if (nodesA.length !== nodesB.length) {
                return { value: false };
            }
            var _loop_2 = function (nodeA) {
                if (nodeA.type === 'comment') {
                    return "continue";
                }
                var found = nodesB.find(function (nodeB) { return isSameNode(nodeA, nodeB); });
                if (!found) {
                    return { value: false };
                }
            };
            try {
                for (var nodesA_1 = (e_1 = void 0, tslib_1.__values(nodesA)), nodesA_1_1 = nodesA_1.next(); !nodesA_1_1.done; nodesA_1_1 = nodesA_1.next()) {
                    var nodeA = nodesA_1_1.value;
                    var state_2 = _loop_2(nodeA);
                    if (typeof state_2 === "object")
                        return state_2;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (nodesA_1_1 && !nodesA_1_1.done && (_a = nodesA_1.return)) _a.call(nodesA_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        };
        for (var i = 0; i < firstSelectorAChunks.length; i++) {
            var state_1 = _loop_1(i);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        return true;
    });
}
exports.matchSelectorParts = matchSelectorParts;
function isSameNode(nodeA, nodeB) {
    if (nodeA.type !== nodeB.type) {
        return false;
    }
    if (nodeA.name !== nodeB.name) {
        return false;
    }
    if ((nodeA.type === 'attribute' && nodeB.type === 'attribute') ||
        (nodeA.type === 'comment' && nodeB.type === 'comment') ||
        (nodeA.type === 'pseudo-class' && nodeB.type === 'pseudo-class')) {
        return nodeA.content === nodeB.content;
    }
    if ((nodeA.type === 'invalid' && nodeB.type === 'invalid') ||
        (nodeA.type === 'spacing' && nodeB.type === 'spacing')) {
        return nodeA.value === nodeB.value;
    }
    if ((nodeA.type === 'element' && nodeB.type === 'element') ||
        (nodeA.type === 'universal' && nodeB.type === 'universal')) {
        return nodeA.namespace === nodeB.namespace;
    }
    if (nodeA.type === 'operator' && nodeB.type === 'operator') {
        return nodeA.operator === nodeB.operator;
    }
    if (nodeA.type === 'selector' && nodeB.type === 'selector') {
        if (nodeA.nodes.length !== nodeB.nodes.length) {
            return false;
        }
        return nodeA.nodes.every(function (node, i) { return isSameNode(node, nodeB.nodes[i]); });
    }
    if ((nodeA.type === 'nested-pseudo-class' && nodeB.type === 'nested-pseudo-class') ||
        (nodeA.type === 'selectors' && nodeB.type === 'selectors')) {
        if (nodeA.nodes.length !== nodeB.nodes.length) {
            return false;
        }
        return nodeA.nodes.every(function (node, i) { return isSameNode(node, nodeB.nodes[i]); });
    }
    return true;
}
function separateChunks(selectorNode) {
    var selectors = [];
    walkNodes(selectorNode, function (node) {
        if (node.type === 'selectors') {
            // skip
        }
        else if (node.type === 'selector') {
            selectors.push([{ type: 'selector', nodes: [] }]);
        }
        else if (node.type === 'operator') {
            var chunks = selectors[selectors.length - 1];
            chunks.push({ type: node.type, operator: node.operator, nodes: [] });
        }
        else if (node.type === 'spacing') {
            var chunks = selectors[selectors.length - 1];
            chunks.push({ type: node.type, operator: node.value, nodes: [] });
        }
        else if (node.type === 'pseudo-element') {
            var chunks = selectors[selectors.length - 1];
            chunks.push({ type: node.type, operator: '::' + node.name, nodes: [] });
        }
        else {
            var chunks = selectors[selectors.length - 1];
            chunks[chunks.length - 1].nodes.push(node);
        }
    });
    return selectors;
}
function walkNodes(node, visitor, index, nodes) {
    if (index === void 0) { index = 0; }
    if (nodes === void 0) { nodes = [node]; }
    if (!node) {
        return;
    }
    var doNext = visitor(node, index, nodes);
    if (doNext === false) {
        return false;
    }
    if (doNext === true) {
        return true;
    }
    if ('nodes' in node) {
        for (var i = 0; i < node.nodes.length; i++) {
            doNext = walkNodes(node.nodes[i], visitor, i, node.nodes);
            if (doNext === false) {
                return false;
            }
        }
    }
}
exports.walkNodes = walkNodes;
//# sourceMappingURL=match-selector-parts.js.map